module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "fixed header-animation",
    class: {
      'transparent': _vm.transparent
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.transparent) ? _c('router-link', {
    staticClass: "navbar-brand",
    class: {
      'light': _vm.transparent
    },
    staticStyle: {
      "margin-top": "0",
      "padding": "5px 0"
    },
    attrs: {
      "to": "/",
      "href": "index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/ceo/logo_hotel_white.png",
      "height": "60",
      "alt": "Logo"
    }
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand ",
    class: {
      'dark nodisplay': _vm.transparent
    },
    staticStyle: {
      "margin-top": "0",
      "padding": "5px 0"
    },
    attrs: {
      "to": "/",
      "href": "index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/ceo/logo_hotel.png",
      "height": "45",
      "alt": "Logo"
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "mobile_menu navbar-collapse",
    attrs: {
      "id": "main_menu"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    directives: [{
      name: "lang",
      rawName: "v-lang.menu",
      modifiers: {
        "menu": true
      }
    }],
    staticClass: "mobile_menu_title",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.inicio",
      modifiers: {
        "inicio": true
      }
    }],
    attrs: {
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.habitaciones",
      modifiers: {
        "habitaciones": true
      }
    }],
    attrs: {
      "to": "/site/rooms"
    }
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.contacto",
      modifiers: {
        "contacto": true
      }
    }],
    attrs: {
      "to": "/site/contact"
    }
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.blog",
      modifiers: {
        "blog": true
      }
    }],
    attrs: {
      "to": "/site/blog"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "menu_button"
  }, [_c('a', {
    staticClass: "button btn_yellow",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showAlert($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.book",
      modifiers: {
        "book": true
      }
    }]
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle mobile_menu_btn",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".mobile_menu",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5d9e306"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerTransparent/HeaderTransparent.vue
// module id = 395
// module chunks = 0